import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  'de': {
    confirmation: {
      terminate: 'Ausstellung abschliessen',
      toOverview: 'Zurück zur Übersicht',
    },
    evaluation: {
      next: 'Weiter',
    },
    newsletter: {
      title: 'Sollen wir dir einen Link zu deinen Aufnahmen senden?',
      emailPlaceholder: 'max@muster.ch',
      emailLabel: 'E-Mail:',
      next: 'Weiter',

    }
  },
  'fr': {
    confirmation: {
      terminate: 'Terminer l\'exposition',
      toOverview: 'Retour au menu',
    },
    evaluation: {
      next: 'Continuer',
    },
    newsletter: {
      title: 'Souhaitez-vous recevoir un lien pour télécharger vos enregistrements ?',
      emailPlaceholder: 'Veuillez saisir votre adresse e-mail',
      emailLabel: 'E-mail :',
      next: 'Continuer',

    }
  }
};

const i18n = new VueI18n({
  locale: 'de',
  messages,
});

export default i18n;